import React from 'react';
import { customerProblems } from '../data/mock';
import { TrendingUp, Link, HelpCircle, Calculator, AlertTriangle } from 'lucide-react';

const iconMap = {
  'trending-up': TrendingUp,
  'link': Link,
  'help-circle': HelpCircle,
  'calculator': Calculator
};

const ProblemSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center px-4 py-2 bg-red-100 rounded-full mb-6">
              <AlertTriangle className="w-4 h-4 text-red-600 mr-2" />
              <span className="text-red-700 font-semibold text-sm">Die Herausforderung</span>
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Steigende Energiekosten
              <span className="block text-red-600">belasten Haushalte</span>
            </h2>
            
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Viele Eigenheimbesitzer kennen das Problem: Die Stromrechnung wird jedes Jahr höher, 
              während die Abhängigkeit vom Energieversorger steigt. Hinzu kommt ein unübersichtlicher 
              Markt mit vielen Anbietern.
            </p>

            {/* Statistics Box */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200">
              <div className="flex items-center gap-6">
                <div className="text-5xl font-bold text-red-600">+47%</div>
                <div className="text-slate-600">
                  <div className="font-semibold text-slate-900 text-lg">Strompreisanstieg</div>
                  <div className="text-sm">in den letzten 5 Jahren in Deutschland</div>
                </div>
              </div>
              <div className="mt-6 h-3 bg-slate-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-red-400 to-red-600 w-[75%] rounded-full" />
              </div>
              <p className="mt-4 text-sm text-slate-500">Quelle: Bundesnetzagentur, Strompreisentwicklung 2019-2024</p>
            </div>
          </div>

          {/* Right - Problem Cards */}
          <div className="grid sm:grid-cols-2 gap-5">
            {customerProblems.map((problem, index) => {
              const IconComponent = iconMap[problem.icon];
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-7 shadow-sm border border-slate-200 hover:shadow-lg hover:border-red-200 transition-all duration-300 group"
                >
                  <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center mb-5 group-hover:bg-red-100 transition-colors">
                    <IconComponent className="w-7 h-7 text-red-500" />
                  </div>
                  <h3 className="font-bold text-slate-900 mb-2 text-lg">{problem.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{problem.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
